import { render } from "./quizes.vue?vue&type=template&id=37de3483&scoped=true"
import script from "./quizes.vue?vue&type=script&lang=js"
export * from "./quizes.vue?vue&type=script&lang=js"

import "./quizes.vue?vue&type=style&index=0&id=37de3483&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37de3483"]])

export default __exports__